<script>
export default {
  data: () => ({
    //
  }),
};
</script>

<template>
  <v-container>
    <strong class="title_text"
      ><h2>{{ $t("faq_title") }}</h2></strong
    >
    <div class="-cart">
      <v-expansion-panels multiple>
        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question1")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer1") }}
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question2")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer2") }}
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question3")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer3") }}
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question4")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer4") }}
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question5")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer5") }}
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question6")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer6") }}
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question7")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer7") }}
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question8")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer8") }}
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question9")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer9") }}
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question10")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer10") }}
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question11")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer11") }}
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question12")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer12") }}
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question13")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer13") }}
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question14")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer14") }}
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="header_question">{{
            $t("faq_question15")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content class="body_answer">
            {{ $t("faq_answer15") }}
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
  </v-container>
</template>
<style lang="scss" scoped>
.title_text {
  text-align: left;
  margin: 20px;
}

.header_question {
  text-align: center;
  background: var(--v-accent-base);
  color: white;
  font-size: 18px;
}
.body_answer {
  text-align: left;
  font-size: 16px;
  padding-top: 15px;
}
</style>
